import React from "react";
import { Button } from "react-bootstrap";

const ErrorPage = () => {
  return (
    <div className="center">
      <h2>Page not Found</h2>
      <Button href="/">Home</Button>
    </div>
  );
};

export default ErrorPage;
